<script>
  export default {
    props: {
      column: {
        type: Object,
        required: true,
      },
    },
    render(createElement) {
      if (this.column.label) {
        return createElement("div", this.column.label).children[0];
      }
      return this.column.renderHeader(createElement, {column: this.column});
    },
  };
</script>
